import React from 'react';
import { Box, Button, IconButton, makeStyles } from '@material-ui/core';
import { SeriesResourceCardActions } from 'containers/Series/components/SeriesResourceCardActions';
import { DownloadIcon } from './icons/DownloadIcon';

const useStyles = makeStyles({
  downloadButton: {
    borderRadius: 20,
  },
  iconButton: {
    border: '1px solid #E0E0E0',
    padding: 7,
    alignSelf: 'center',
  },
});

export const CourseActions = ({
  pdf,
  handleDownloadPdf,
  pdfLabel,
  seriesSiteCopy,
  isSeriesComplete,
  onCheckboxChange,
  handleNext,
  fontSize,
  completed,
  isDownloadingPdf = false,
  isManualSeriesCompletion = false,
  resources = [],
  completedResourcesIds = [],
  small,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" justifyContent="space-between" mb={2} {...rest}>
      {pdf &&
        (small ? (
          <IconButton
            className={classes.iconButton}
            onClick={handleDownloadPdf}
          >
            <DownloadIcon />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDownloadPdf}
            className={classes.downloadButton}
            disabled={isDownloadingPdf}
          >
            {pdfLabel}
          </Button>
        ))}
      <Box marginLeft="auto">
        <SeriesResourceCardActions
          seriesSiteCopy={seriesSiteCopy}
          completed={completed}
          onChange={onCheckboxChange}
          isManualSeriesCompletion={isManualSeriesCompletion}
          isSeriesComplete={isSeriesComplete}
          handleNext={handleNext}
          fontSize={fontSize}
          resources={resources}
          completedResourcesIds={completedResourcesIds}
        />
      </Box>
    </Box>
  );
};
